angular.module("ainapp")
    .controller("EmployeeAttachmentController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Employee Attachment";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.basePath = config.basePath;

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })

            $scope.AttachmentTypes = [];
            MainService.AttachmentTypesInDropdown().then(function (response) {
                $scope.AttachmentTypes = response.data;
            })

            $scope.Init = function () {

                $scope.EmployeeAttachment = {
                    DocNo: "",
                    FilePath: "",
                    EmployeeId: "",
                    AttachmentTypeId: "",
                }

                $scope.load = 0;
                $scope.dirEmp = false;

                if ($stateParams.EmployeeId > 0) {
                    $scope.dirEmp = true;
                    $scope.EmployeeAttachment.EmployeeId = $stateParams.EmployeeId;
                }


            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.EmployeeId = $stateParams.EmployeeId;
                        MainService.EmployeeAttachmentInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },

                            "AttachmentType.Name": {
                                type: "string",
                                editable: false,
                            },
                            DocNo: {
                                type: "string",
                                editable: false,
                            },

                            FilePath: {
                                type: "string",
                                editable: false,
                            },
                            ExpiryDate: {
                                type: "date",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee Name",
                        headerTemplate: "{{LanguageData.Employee}}",

                        },

                    {
                        field: "AttachmentType.Name",
                        title: "AttachmentType Name",
                        headerTemplate: "{{LanguageData.AttachmentType}}",

                        },
                    {
                        field: "DocNo",
                        title: "Doc No",
                        headerTemplate: "{{LanguageData.DocNo}}",

                        },

                    {
                        field: "FilePath",
                        title: "File",
                        headerTemplate: "{{LanguageData.FilePath}}",
                        template: '<a href="{{basePath}}{{dataItem.FilePath}}" target="_blank"> View File</a>'
                    }, {
                        field: "ExpiryDate",
                        title: "Expiry Date",
                        template: "#= kendo.toString(kendo.parseDate(ExpiryDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEmployeeAttachment($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $scope.EmployeeAttachment = data;
                //$scope.$apply();
            }


            $scope.AddData = function () {

                if ($scope.EmployeeAttachment.DocNo == "") {
                    toastr.warning($scope.LanguageData.EntertheDocNo);


                } else if ($scope.EmployeeAttachment.EmployeeId == "") {
                    toastr.warning($scope.LanguageData.SelectEmployee);

                } else if ($scope.EmployeeAttachment.AttachmentTypeId == "") {
                    toastr.warning($scope.LanguageData.SelectAttachmentType);


                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddEmployeeAttachment($scope.EmployeeAttachment).then(function (response) {
                        if (response.data == 1) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success($scope.LanguageData.Success);

                            $scope.Init();
                            $scope.load = 0;
                        } else if (response.data == 2) {
                            toastr.error($scope.LanguageData.DataExist);
                            $scope.load = 0;
                        } else {
                            toastr.error($scope.LanguageData.Error);
                            $scope.load = 0;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }



            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.EmployeeAttachment.FilePath = objXhr.responseText;
                            if ($scope.EmployeeAttachment.FilePath.includes("error")) {
                                $scope.EmployeeAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.EmployeeAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }





                }])
